// @ts-check
class TjbFacetFiltersForm extends FacetFiltersForm {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.selectors = {
      filterToggle: '[data-filter-toggle]',
      filterCollapsible: '[data-facets-collapsible]',
      filterCollapsibleContent: '[data-facets-collapsible-content]',
      forms: 'facet-filters-form form, tjb-facet-filters-form form',
      activeFilters: '[data-active-filters]',
      activeFiltersCount: '[data-active-filters-count]',
      activeFiltersClear: '[data-active-filters-clear]'
    }

    this.bindFilterToggle()
    this.bindResizeObserver()
    this.bindAdditionalRender()
  }

  bindFilterToggle() {
    const toggles = Array.from(this.querySelectorAll(this.selectors.filterToggle))
    if (toggles.length) {
      toggles.forEach(toggle =>
        toggle.addEventListener('click', this.toggleFilters.bind(this))
      )
    }
  }

  bindResizeObserver() {
    const collapsible = this.querySelector(this.selectors.filterCollapsible)

    const observer = new ResizeObserver(entries => this.resizeContentHeight())
    observer.observe(collapsible)
  }

  bindAdditionalRender() {
    document.addEventListener(FacetFiltersForm.renderEvent, this.renderAdditionalCustomElements.bind(this))
  }

  toggleFilters() {
    const collapsible = this.querySelector(this.selectors.filterCollapsible)

    if (collapsible.classList.contains('closed')) {
      this.setContentHeight()
      collapsible.classList.remove('closed')
    } else {
      collapsible.style.height = 0
      collapsible.classList.add('closed')
    }
  }

  resizeContentHeight() {
    const collapsible = this.querySelector(this.selectors.filterCollapsible)

    if (!collapsible.classList.contains('closed')) {
      this.setContentHeight()
    }
  }

  setContentHeight() {
    const collapsible = this.querySelector(this.selectors.filterCollapsible)
    const height = this.getContentHeight()
    collapsible.style.height = height
  }

  getContentHeight() {
    const collapsibleContent = this.querySelector(this.selectors.filterCollapsibleContent)
    return `${collapsibleContent.getBoundingClientRect().height}px`
  }

  /**
   * Need to override original due to selector using tag name
   *
   * @param {*} event
   */
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(this.selectors.forms);
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  renderAdditionalCustomElements({ detail: { html }}) {
    const activeFiltersCount = parseInt(html.querySelector(this.selectors.activeFiltersCount).innerHTML, 10) || 0

    if (activeFiltersCount > 0 ) {
      const activeFiltersCountEl = this.querySelector(this.selectors.activeFiltersCount)
      activeFiltersCountEl.innerHTML = activeFiltersCount.toString()

      const activeFiltersEl = this.querySelector(this.selectors.activeFilters)
      const activeFiltersClearEl = this.querySelector(this.selectors.activeFiltersClear)
      activeFiltersEl.classList.remove('hidden')
      activeFiltersClearEl.classList.remove('hidden')
    } else {
      const activeFiltersEl = this.querySelector(this.selectors.activeFilters)
      const activeFiltersClearEl = this.querySelector(this.selectors.activeFiltersClear)
      activeFiltersEl.classList.add('hidden')
      activeFiltersClearEl.classList.add('hidden')
    }
  }
}

customElements.define('tjb-facet-filters-form', TjbFacetFiltersForm)

class TjbFacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });

    this.selectors = {
      form: 'tjb-facet-filters-form, facet-filters-form'
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest(this.selectors.form) || document.querySelector(this.selectors.form);
    form.onActiveFilterClick(event);
  }
}

customElements.define('tjb-facet-remove', TjbFacetRemove);
